webpackJsonp([15],{

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _component = __webpack_require__(33);

var _component2 = _interopRequireDefault(_component);

var _debounce2 = __webpack_require__(206);

var _debounce3 = _interopRequireDefault(_debounce2);

var _template2 = __webpack_require__(91);

var _template3 = _interopRequireDefault(_template2);

var _remove2 = __webpack_require__(209);

var _remove3 = _interopRequireDefault(_remove2);

var _isEmpty2 = __webpack_require__(208);

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _predictiveSearchItemInsights = __webpack_require__(616);

var _predictiveSearchItemInsights2 = _interopRequireDefault(_predictiveSearchItemInsights);

var _constants = __webpack_require__(92);

var _gsap = __webpack_require__(90);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PredictiveSearch = function (_Component) {
  _inherits(PredictiveSearch, _Component);

  function PredictiveSearch(el, config) {
    _classCallCheck(this, PredictiveSearch);

    return _possibleConstructorReturn(this, (PredictiveSearch.__proto__ || Object.getPrototypeOf(PredictiveSearch)).call(this, el, config));
  }

  _createClass(PredictiveSearch, [{
    key: 'setupDefaults',
    value: function setupDefaults() {
      this.dom = {
        $container: this.$el,
        $serchBox: this.$el.find('.wh-search-box'),
        $input: this.$el.find('.wh-search-box__field'),
        $searchBtn: this.$el.find('.wh-search-box__button'),
        $results: this.$el.find('.wh-predictive-search')
      };

      this.cssClasses = {
        searchGroup: 'wh-predictive-search-group'
      };

      this.currentRequest = [];
    }
  }, {
    key: 'addListeners',
    value: function addListeners() {
      var _this2 = this;

      this.dom.$input.on('keyup input', (0, _debounce3.default)(function (e) {
        _this2.onInputUp(e);
      }, 100));

      this.dom.$searchBtn.on('click touch', this.onSearch.bind(this));
      this.$el.on('click touch', '.wh-predictive-search-group__items .keyword', this.onKeywordClick.bind(this));
      this.$el.on('click touch', '.wh-predictive-search-group__title', this.onHeadingClick.bind(this));
    }
  }, {
    key: 'getResults',
    value: function getResults(keyword, contenttype, requestIndex) {
      var _this3 = this;

      var queryParms = { keyword: keyword, contenttype: contenttype };
      if (window.location.search.indexOf('person=') !== -1 && window.location.search.indexOf('personname=') !== -1 && contenttype === 'insight') {
        queryParms = { keyword: keyword, contenttype: contenttype, isforperson: 1 };
      }
      this.dom.$serchBox.addClass('loading');

      return $.ajax({
        url: this.config.predictiveEndpoint,
        data: queryParms,
        beforeSend: function beforeSend() {
          if (_this3.currentRequest[requestIndex] && _this3.currentRequest[requestIndex] !== null) {
            _this3.currentRequest[requestIndex].abort();
          }
        }
      });
    }
  }, {
    key: 'renderResults',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(value) {
        var data, items, noResults, noResultsString;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Promise.all([this.currentRequest[0] = this.getResults(value, 'news', 2)]);

              case 2:
                data = _context.sent;


                (0, _remove3.default)(data, function (n) {
                  return (0, _isEmpty3.default)(n);
                });

                this.dom.$serchBox.removeClass('loading');

                this.$el.trigger('search:keyword', data);

                items = '';


                if (data.length > 0) {
                  data.forEach(function (item) {
                    items += (0, _template3.default)(_predictiveSearchItemInsights2.default)(item);
                  });

                  this.dom.$results.html(items);
                } else {
                  noResults = this.dom.$results.data('no-results-txt');
                  noResultsString = '<li class="wh-predictive-search__none">' + noResults + '</li>';


                  this.dom.$results.find('li').remove();
                  this.dom.$results.html(noResultsString);
                }

                this.dom.$results.removeClass('loading');

                if (!this.dom.$results.hasClass('expanded')) {
                  this.dom.$results.addClass('expanded');
                  _gsap.TweenLite.set(this.dom.$results, { height: 'auto', ease: _gsap.Expo.easeOut });
                  _gsap.TweenLite.from(this.dom.$results, 0.4, { height: 0, ease: _gsap.Expo.easeInOut });
                }

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function renderResults(_x) {
        return _ref.apply(this, arguments);
      }

      return renderResults;
    }()
  }, {
    key: 'destroyResults',
    value: function destroyResults() {
      var _this4 = this;

      _gsap.TweenLite.to(this.dom.$results, 0.5, {
        height: 0, ease: _gsap.Expo.easeOut, onComplete: function onComplete() {
          _this4.dom.$results.removeClass('expanded');
          _this4.dom.$results.find('li').remove();
        }
      });
    }
  }, {
    key: 'onInputUp',
    value: function onInputUp(e) {
      var value = this.dom.$input.val().trim();

      if (value.length < 2) {
        this.destroyResults();

        return;
      }

      if (e.which === 13) {
        this.searchOnNewsListingPage(value);
        return;
      }

      this.renderResults(value).catch(function (err) {
        if (err.statusText !== 'abort') {
          console.error('There was an error getting your results', err);
        }
      });
    }
  }, {
    key: 'searchOnNewsListingPage',
    value: function searchOnNewsListingPage(value) {
      window.open('' + this.dom.$serchBox.data('search-url') + (value ? '?keyword=' + value : ''), '_self');
    }
  }, {
    key: 'onKeywordClick',
    value: function onKeywordClick(e) {
      var $target = $(e.currentTarget);
      var searchGroup = $target.parents('.' + this.cssClasses.searchGroup).data('predictive-search-group');
      var keyword = $target.html();
      var value = $target.data('value');

      this.$el.trigger('search:filter', { filterGroup: 'insights', value: value, keyword: keyword });

      this.destroyResults();
    }
  }, {
    key: 'onHeadingClick',
    value: function onHeadingClick(e) {
      var $target = $(e.currentTarget);
      if ($target.hasClass('wh-predictive-search-group__title--false')) {
        return;
      }

      this.searchOnNewsListingPage();
    }
  }, {
    key: 'onSearch',
    value: function onSearch(e) {
      e.preventDefault();

      var value = this.dom.$input.val().trim();
      this.searchOnNewsListingPage(value);
    }
  }]);

  return PredictiveSearch;
}(_component2.default);

exports.default = PredictiveSearch;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),

/***/ 616:
/***/ (function(module, exports) {

module.exports = "<li class=wh-predictive-search-group data-predictive-search-group=\"<%= GroupName %>\" data-predictive-search-subtype=\"<%= Subtype %>\"> <h3 class=\"wh-predictive-search-group__title wh-predictive-search-group__title--view-all-<%= ViewAll %>\"> <%= GroupName %> <% if(ViewAll) { %> <span class=wh-predictive-search-group__hover>View All</span> <% } %> </h3> <ul class=wh-predictive-search-group__items> <% for (let i = 0; i < Listing.length; i++) { %> <li> <% if(Listing[i].Link) { %> <a href=\"<%= Listing[i].Link %>\"><%= Listing[i].Title %></a> <% } else { %> <a class=keyword href=# data-value=\"<%= Listing[i].Value %>\"><%= Listing[i].Title %></a> <% } %> </li> <% }; %> </ul> </li> ";

/***/ })

});


// WEBPACK FOOTER //
// 15.52f5a0f9.bundle.js